/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Terraformdel";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p>{"To delete a resource with "}<_components.a href="/tooling/infrastructure/terraform">{"Terraform"}</_components.a>{":"}</_components.p>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p>{"Remove its definition from the Terraform file."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Run this command to apply the changes:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"terraform"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" apply"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}</_components.li>{"\n"}</_components.ol></>;
}

export default MDXLayout